import { useQuery } from "@tanstack/react-query";
import { Navigate } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { useSeo } from "@/lib/useSeo";
import { getList } from "@/lib/api";
import { IMG } from "@/lib/images";
import { PageHeader } from "@/components/Editorial";

const STATUS = { en_cours: "En cours", a_venir: "À venir", termine: "Terminé" };
const STATUS_COLOR = { en_cours: "#D4B978", a_venir: "#C6A76A", termine: "rgba(243,233,210,0.5)" };

export default function Projets() {
  const { data: projects = [], isLoading } = useQuery({ queryKey: ["projects"], queryFn: () => getList("projects") });

  useSeo({
    title: "Mes projets",
    description: "Les projets de Dorothée Lancelot : Les Chroniques de l'Étrange, nouveaux livres, conférences, contenus historiques, podcast et développement de l'association AAESAD.",
    path: "/projets",
  });

  if (!isLoading && projects.length === 0) return <Navigate to="/" replace />;

  return (
    <div>
      <PageHeader eyebrow="En mouvement" title="Mes projets" intro="Des livres, des conférences, des contenus et des projets de transmission qui se répondent, et se construisent au fil du temps." image={IMG.map} />
      <section className="dl-container py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {projects.map((p) => (
              <div key={p.id} className="dl-card overflow-hidden" data-testid={`project-${p.id}`}>
                {p.image_url && <img src={p.image_url} alt={p.title} className="w-full h-48 object-cover" loading="lazy" />}
                <div className="p-7">
                  <span className="text-[0.6rem] tracking-widest uppercase font-bold" style={{ color: STATUS_COLOR[p.status] || "#C6A76A" }}>
                    {STATUS[p.status] || p.status}
                  </span>
                  <h3 className="serif text-2xl text-[#F3E9D2] mt-2">{p.title}</h3>
                  {p.description && <p className="text-sm text-[#F3E9D2]/70 mt-2">{p.description}</p>}
                  {p.link && <a href={p.link} target="_blank" rel="noreferrer" className="dl-link text-sm mt-3 inline-flex items-center gap-1">Découvrir <ExternalLink size={12} /></a>}
                </div>
              </div>
            ))}
          </div>
      </section>
    </div>
  );
}
